import '../../App.css'
import React from 'react';
import { useEffect, useRef, useState, useMemo } from 'react';
import Cricket from 'components/cricket';
import Soccer from 'components/soccer';
import Tennis from 'components/tennis';
import HorseRacing from 'components/horseRacing';
import GreyhoundRacing from 'components/greyhoundRacing';
import Partners from 'components/partners';
import { useDispatch, useSelector } from 'react-redux';
import { Carousel } from 'antd';
import { fetchSportsEvents, fetchSportsEventsBeforeLogin } from '../../redux/slice/events/eventsSlice';
import { fetchUserProfile } from 'services/users';

import { useWebSocket } from "../../context/WebSocketProvider";
import WebSocketEventEmitter from "../../context/eventEmitter";
function Home() {
    const dispatch = useDispatch();
    const { cricketEvents, soccerEvents, tennisEvents, loading, events } = useSelector((state) => state.events);
    const profileData = useSelector((state) => state.authSlice.profileData);
    const { isAuthenticated } = useSelector((state) => state.authSlice);

    const topGameImages = Array.from({ length: 9 }, (_, i) =>
        `/assets/images/topGames/topgame${i + 1}.webp`
    );
    const [currentIndex, setCurrentIndex] = useState(0);
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => {
                return (prevIndex + 1) % topGameImages.length;
            });
        }, 3000);

        return () => clearInterval(interval);
    }, []);
    const circularImages = [...topGameImages, ...topGameImages];



    useEffect(() => {
        if (isAuthenticated) {
            dispatch(fetchSportsEvents());
        }
        else {
            dispatch(fetchSportsEventsBeforeLogin())
        }
    }, [isAuthenticated, dispatch]);


    useEffect(() => {
        const handleMessage = async (data) => {
            if (data.action == "USER_BLOCK_UPDATE") {
                let market = data.data;
                console.log("user block Details SOCKET RESPONDING");
                if (market) {
                    const profileResponse = await fetchUserProfile();
                    console.log('profileResponse', profileResponse)
                    // dispatch(setProfileData(profileResponse?.data?.data));
                }
            }

            // if (data.action == "USER_EVENT_ACTION") {
            //     let market = data.data;
            //     if (market) {
            //         if (market.type == "event") {
            //             dispatch(getAllEvents({
            //                 user_id: userInfo ? userInfo._id : "",
            //             }));
            //         }
            //     }
            // }

        };

        WebSocketEventEmitter.on("message", handleMessage);

        return () => {
            WebSocketEventEmitter.off("message", handleMessage); // Cleanup on unmount
        };
    }, [profileData, dispatch])

    return (
        <div className='relative min-w-full'>
            <div className='grid grid-cols-12'>
                {
                    !isAuthenticated &&
                    <>
                        <div className='col-span-12'>
                            <img src="/assets/images/main-banner.webp" className='w-full hidden lg:block' alt="Desktop Banner" />
                            <img src="/assets/images/main-banner-mobile.webp" className='w-full block lg:hidden' alt="Mobile Banner" />
                        </div>

                        <div className='col-span-12 lg:px-[6px] mt-[5px] lg:mt-[10px] mb-[5px]'>
                            <div className='grid grid-cols-12'>
                                {/* <div className='col-span-4 px-[3px] cursor-pointer'>
                                    <img src='/assets/images/bonus-1.webp' className='w-full' />
                                </div> */}
                                <div className='col-span-6 px-[3px] cursor-pointer'>
                                    <img src='/assets/images/bonus-4.webp' className='w-full' />
                                </div>
                                <div className='col-span-6 px-[3px] cursor-pointer'>
                                    <img src='/assets/images/bonus-6.webp' className='w-full' />
                                </div>
                            </div>
                        </div>
                        <div className='col-span-12 lg:col-span-6 lg:px-[6px] mb-[5px] '>
                            <img src='/assets/images/RDGIF-1.gif' />
                        </div>
                        <div className='col-span-12 lg:col-span-6 lg:px-[6px] mb-[10px]'>
                            <img src='/assets/images/RDGIF-2.gif' />
                        </div>

                        <div className='col-span-12 lg:px-[6px] mb-[15px]'>
                            <div className='text-[#000] text-[16px] font-bold mb-[6px]'>Top Games</div>
                            <div className='relative w-full overflow-hidden'>
                                <div
                                    className='flex space-x-4 transition-transform duration-500 ease-in-out'
                                    style={{
                                        transform: `translateX(-${currentIndex * (165 + 16)}px)`,
                                        width: `${(circularImages.length * (165 + 16))}px`
                                    }}
                                >
                                    {circularImages.map((image, index) => (
                                        <div
                                            key={index}
                                            className='flex-shrink-0'
                                            style={{
                                                width: '165px',
                                                height: '100%'
                                            }}
                                        >
                                            <img
                                                src={image}
                                                alt={`Top Game ${(index % topGameImages.length) + 1}`}
                                                className='w-full h-full object-cover rounded-lg cursor-pointer'
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </>
                }

                <div className='col-span-12 lg:px-[6px]'>
                    <Carousel autoplay>
                        {/* <div className='col-span-12'>
                            <img src="/assets/images/banner/desktop_banner_1.jpg" className='w-full !hidden !lg:block' alt="Desktop Banner" />
                            <img src="/assets/images/banner/mobile_banner_1.jpg" className='w-full block lg:hidden' alt="Mobile Banner" />
                        </div>
                        <div className='col-span-12'>
                            <img src="/assets/images/banner/desktop_banner_2.jpg" className='w-full  !hidden !lg:block' alt="Desktop Banner" />
                            <img src="/assets/images/banner/mobile_banner_2.jpg" className='w-full block lg:hidden' alt="Mobile Banner" />
                        </div>
                        <div className='col-span-12'>
                            <img src="/assets/images/banner/desktop_banner_3.jpg" className='w-full  !hidden !lg:block' alt="Desktop Banner" />
                            <img src="/assets/images/banner/mobile_banner_13.jpg" className='w-full !block !lg:hidden' alt="Mobile Banner" />
                        </div>
                        <div className='col-span-12'>
                            <img src="/assets/images/banner/desktop_banner_9.jpg" className='w-full  !hidden !lg:block' alt="Desktop Banner" />
                            <img src="/assets/images/banner/mobile_banner_9.jpg" className='w-full !block !lg:hidden' alt="Mobile Banner" />
                        </div>
                        <div className='col-span-12'>
                            <img src="/assets/images/banner/desktop_banner_11.jpg" className='w-full  !hidden !lg:block' alt="Desktop Banner" />
                            <img src="/assets/images/banner/mobile_banner_11.jpg" className='w-full !block !lg:hidden' alt="Mobile Banner" />
                        </div>
                        <div className='col-span-12'>
                            <img src="/assets/images/banner/desktop_banner_12.jpg" className='w-full  !hidden !lg:block' alt="Desktop Banner" />
                            <img src="/assets/images/banner/mobile_banner_12.jpg" className='w-full !block !lg:hidden' alt="Mobile Banner" />
                        </div>
                        <div className='col-span-12'>
                            <img src="/assets/images/banner/desktop_banner_13.jpg" className='w-full  !hidden !lg:block' alt="Desktop Banner" />
                            <img src="/assets/images/banner/mobile_banner_13.jpg" className='w-full !block !lg:hidden' alt="Mobile Banner" />
                        </div>
                        <div className='col-span-12'>
                            <img src="/assets/images/banner/desktop_banner_14.jpg" className='w-full  !hidden !lg:block' alt="Desktop Banner" />
                            <img src="/assets/images/banner/mobile_banner_14.jpg" className='w-full !block !lg:hidden' alt="Mobile Banner" />
                        </div>
                        <div className='col-span-12'>
                            <img src="/assets/images/banner/desktop_banner_15.jpg" className='w-full  !hidden !lg:block' alt="Desktop Banner" />
                            <img src="/assets/images/banner/mobile_banner_15.jpg" className='w-full !block !lg:hidden' alt="Mobile Banner" />
                        </div>
                        <div className='col-span-12'>
                            <img src="/assets/images/banner/desktop_banner_16.jpg" className='w-full  !hidden !lg:block' alt="Desktop Banner" />
                            <img src="/assets/images/banner/mobile_banner_16.jpg" className='w-full !block !lg:hidden' alt="Mobile Banner" />
                        </div> */}
                    </Carousel>
                </div>
                {/* Cricket */}
                <div className='col-span-12 lg:px-[6px]  '>
                    <Cricket events={
                        cricketEvents && [...cricketEvents]
                            .sort((a, b) => new Date(a.open_date) - new Date(b.open_date))
                            .slice(0, 5)
                    } />
                </div>
                {/* Soccer */}
                <div className='col-span-12 lg:px-[6px]  '>
                    <Soccer events={
                        soccerEvents && [...soccerEvents]
                            .sort((a, b) => new Date(a.open_date) - new Date(b.open_date))
                            .slice(0, 5)
                    } />
                </div>
                {/* Tennis */}
                <div className='col-span-12 lg:px-[6px]  '>
                    <Tennis events={
                        tennisEvents && [...tennisEvents]
                            ?.sort((a, b) => new Date(a.open_date) - new Date(b.open_date))
                            ?.slice(0, 5)
                    } />
                </div>
                {/* Horse Racing */}
                {/* <div className='col-span-12 lg:px-[6px]  '>
                    <HorseRacing />
                </div> */}
                {/* Greyhound Racing */}
                {/* <div className='col-span-12 lg:px-[6px]  '>
                    <GreyhoundRacing />
                </div> */}
                {
                    !isAuthenticated &&
                    <>
                        <div className='col-span-12 lg:px-[6px]' s>
                            <img src="/assets/images/pg-banner.webp" alt="" className="rounded-[10px]" />
                        </div>
                        <div className='col-span-12 partner_logo'>
                            <Partners />
                        </div>
                    </>
                }

            </div>
        </div >
    )
}

export default Home;
